<template>
  <div class="BasketBanner" :class="{'BasketBanner--show': displayBasketBanner}">
    <div class="BasketBanner-content page text-right text-colorWhite">
      <router-link class="position-inlineBlock p-12" :to="path.basket">Voir mon panier <icon class="ml-8" name="basket" /></router-link>
    </div>
  </div>
</template>

<script>
import paths from '/src/script/config/paths'
import EventBus from '/src/script/modules/eventBus'
import { getBasket } from '/src/script/modules/basket'
import path from "/src/script/config/paths"
import Icon from '../Icon/Icon.vue'

export default {
  name: "BasketBanner",
  components: { Icon },
  data() {
    return {
      path,
      basketItemNumber: 0,
      forceHidden: false,
    }
  },
  computed: {
    displayBasketBanner() {
      if (this.forceHidden) {
        return false
      }

      return this.basketItemNumber > 0
    }
  },
  methods: {
    updateBasketItemNumber() {
      const basket = getBasket()
      this.basketItemNumber = basket?.length || 0
    },
    checkRoute() {
      this.forceHidden = [paths.basket, paths.order, paths.paymentStatus].includes(window.location.pathname)
    }
  },
  mounted() {
    this.checkRoute()
    this.updateBasketItemNumber()

    EventBus.$on('basket', () => {
      this.updateBasketItemNumber()
    })
  },
  watch:{
    $route () {
      this.checkRoute()
    }
  } 
}
</script>

<style lang="scss" scoped>
@use "/src/style/useful/variables.scss" as variables;

.BasketBanner {
  position: absolute;
  display: grid;
  grid-template-rows: 0fr;
  z-index: -1;
  bottom: 1px;
  left: 0;
  right: 0;
  background: rgba(variables.$color-primary, 0.7);
  backdrop-filter: blur(20px);
  transform: translateY(100%);
  overflow: hidden;
  transition: variables.$delay-basic;

  &--show {
    grid-template-rows: 1fr;
  }

  .icon--basket {
    vertical-align: text-bottom;
  }
}

.BasketBanner-content {
  min-height: 0;
  visibility: hidden;
  transition: variables.$delay-basic;

  .BasketBanner--show & {
    visibility: visible;
  }
}
</style>